import { createSlice } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../libs/utils/constants/async-status';
import IEmail from './email-interface';
import { sendPatientEducationEmail } from './email-thunk';

const initialState = {
    statusCode: 0,
    sendPatientEducationEmailAsyncStatus: AsyncStatus.INITIAL,
} as IEmail;

const emailSlice = createSlice({
    name: 'email',
    initialState,
    reducers: {
        resetSendPatientEducationEmailAsyncStatus: (state: IEmail) => {
            state.sendPatientEducationEmailAsyncStatus = AsyncStatus.INITIAL;
        },
    },
    extraReducers(builder: any) {
        builder
            .addCase(sendPatientEducationEmail.pending, (state: IEmail) => {
                state.sendPatientEducationEmailAsyncStatus =
                    AsyncStatus.LOADING;
            })
            .addCase(
                sendPatientEducationEmail.fulfilled,
                (state: IEmail, { payload }: any) => {
                    if (payload) {
                        state.sendPatientEducationEmailAsyncStatus =
                            AsyncStatus.SUCCESS;
                        state.statusCode = payload?.statusCode;
                    } else {
                        state.sendPatientEducationEmailAsyncStatus =
                            AsyncStatus.SUCCESS;
                        state.statusCode = 204;
                    }
                }
            )
            .addCase(
                sendPatientEducationEmail.rejected,
                (state: IEmail, { payload }: any) => {
                    state.sendPatientEducationEmailAsyncStatus =
                        AsyncStatus.FAILURE;
                    state.statusCode = payload?.statusCode;
                }
            );
    },
});

export const { resetSendPatientEducationEmailAsyncStatus } = emailSlice.actions;
export default emailSlice.reducer;
